const ELLIPSIS_STYLE = {
  lineBreak: 'anywhere',
  display: '-webkit-box',
  WebkitLineClamp: 1,
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden'
}

export function Ellipsis({ children, text, className = '' }) {
  return (
    <span className="flex items-center">
      <span title={text || children} className={className} style={ELLIPSIS_STYLE}>
        {text || children}
      </span>
    </span>
  )
}
